import { render, staticRenderFns } from "./CommonShare.vue?vue&type=template&id=195572b8&scoped=true"
import script from "./CommonShare.vue?vue&type=script&lang=js"
export * from "./CommonShare.vue?vue&type=script&lang=js"
import style0 from "./CommonShare.vue?vue&type=style&index=0&id=195572b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195572b8",
  null
  
)

export default component.exports